// extracted by mini-css-extract-plugin
export default {"wrap":"DeleteUserDialog-wrap","cancelButton":"DeleteUserDialog-cancelButton","deleteButton":"DeleteUserDialog-deleteButton"};